import React from "react"
import { Table, TableHeader, TableHeaderColumn, TableBody, TableRow, TableRowColumn } from "material-ui"
import FloatingActionButton from "material-ui/FloatingActionButton"
import ContentAdd from "material-ui/svg-icons/content/add"
import TableActionBar from "../../../components/layout/TableActionBar"
import strings from "../../../localization/strings"
import AddHierarchyItemDialog from "./AddHierarchyItemDialog"
import _ from "lodash"
import autobind from "class-autobind"
import AccountStore from "../../../stores/AccountStore"
import * as setGlobalHierarchyLevel from "../../../helpers/setGlobalHierarchyLevel"
import * as hierarchyHelper from "../../../helpers/hierarchyHelper"
import * as accountActions from "../../../actions/AccountActions"
import * as userHelper from "../../../helpers/userHelper"
import * as api from "../../../api"
import { IHierarchyItem, IHierarchyDefinition, IHierarchyItemForAccountLevel } from "../../../models"
import { browserHistory } from "react-router"
import AppStateStore from "../../../stores/AppStateStore"
interface IProps {
	hierarchyItem: IHierarchyItem | IHierarchyItemForAccountLevel
	readonly: boolean
	childHierarchyItemsForGlobalFilter: IHierarchyItem[]
	childLevel: IHierarchyDefinition
	canSelectedHaveChildren: boolean
}
interface IState {
	showTable: boolean
	openAddHierarchyItemDialog: boolean
	searchText: string
	filteredHierarchyItems: IHierarchyItem[]
	showTableActionBar: boolean
	selectedHierarchyItems: IHierarchyItem[]
	newItemLabel?: string
}

export default class HierarchyChildren extends React.Component<IProps, IState> {
	constructor(props) {
		super(props)
		this.state = {
			filteredHierarchyItems: props.childHierarchyItemsForGlobalFilter,
			showTable: true,
			openAddHierarchyItemDialog: false,
			searchText: "",
			showTableActionBar: true,
			selectedHierarchyItems: []
		}
		autobind(this)
	}

	componentWillReceiveProps(nextProps) {
		!_.isEqual(this.props.childHierarchyItemsForGlobalFilter, nextProps.childHierarchyItemsForGlobalFilter) &&
			this.setState({
				searchText: "",
				showTableActionBar: false,
				showTable: false,
				filteredHierarchyItems: nextProps.childHierarchyItemsForGlobalFilter
			}, () =>
				this.setState({
					showTableActionBar: true,
					showTable: true
				})
			)

		_.differenceWith(this.props.childHierarchyItemsForGlobalFilter, nextProps.childHierarchyItemsForGlobalFilter, _.isEqual).length > 0 &&
			this.setState({ selectedHierarchyItems: [] })
	}

	getFilteredHierarchyItems(searchText) {
		return searchText ?
			AccountStore.getCurrentAccount().HierarchyItems.slice().filter(item =>
				(item.Label && item.Label.toLowerCase().indexOf(searchText.toLowerCase()) > -1) ||
				(item.CostCenter && item.CostCenter.toLowerCase().indexOf(searchText.toLowerCase()) > -1)
			) :
			this.props.childHierarchyItemsForGlobalFilter
	}

	onDeleteHierarchyItem() {
		let selectedHierarchyItemsAndChildrens = []
		this.state.selectedHierarchyItems.forEach(item => {
			const hierarchyItemAndChildrens = hierarchyHelper.getHierarchyItemAndChildrens(item.Id)
			selectedHierarchyItemsAndChildrens = selectedHierarchyItemsAndChildrens.concat(hierarchyItemAndChildrens)
		})

		const checkCanDeleteHierarchies = []
		selectedHierarchyItemsAndChildrens.forEach(item =>
			checkCanDeleteHierarchies.push(
				new Promise((resolve, reject) =>
					api.checkCanDeleteHierarchy(AccountStore.getCurrentAccount().Id, item.Id)
						.then((res) => resolve(res.data))
						.catch(() => resolve(false))
				)
			)
		)
		AppStateStore.setProgressSnackbarContent("loading")
		Promise.all(checkCanDeleteHierarchies).then(res => {
			AppStateStore.setProgressSnackbarContent("")
			res.includes(false) ?
				AppStateStore.setAlertDialogContent({
					title: strings.Cannot_Delete_Hierarchy,
					content: strings.Cannot_Delete_Hierarchy_because_it_is_already_use
				}) :
				AppStateStore.setConfirmDialogContent({
					title: strings.DELETE_HIERARCHY,
					content: strings.Are_you_sure_want_to_remove_hierarchy,
					confirm: this.handleRemoveHierarchyItems
				})
		})
	}

	handelCellClick(rowNumber, columnId) {
		if (columnId > -1) {
			const hierarchyLevel = this.state.filteredHierarchyItems[rowNumber]
			const accessRight = userHelper.getSupervisorAccessPermissionForHierarchy(hierarchyLevel)
			accessRight ?
				setGlobalHierarchyLevel.setGlobalHierarchyLevel(hierarchyLevel) :
				AppStateStore.setProgressSnackbarContent(strings.You_cant_access_this_hierarchy_item)
		} else {
			if (this.props.readonly) return
			const selectedHierarchyItems = this.state.selectedHierarchyItems.slice()
			const selectedHierarchyItem = this.state.filteredHierarchyItems[rowNumber]
			const indexOf = selectedHierarchyItems.indexOf(selectedHierarchyItem)
			if (indexOf > -1) {
				selectedHierarchyItems.splice(indexOf, 1)
			} else {
				selectedHierarchyItems.push(selectedHierarchyItem)
			}
			this.setSelectedHierarchyItems(selectedHierarchyItems)
		}
	}

	handleRowSelection(result) {
		result === "all" && this.setSelectedHierarchyItems(this.state.filteredHierarchyItems.slice())
		result === "none" && this.setSelectedHierarchyItems([])
	}

	setSelectedHierarchyItems(selectedHierarchyItems) {
		this.setState({ selectedHierarchyItems, showTable: false }, () => this.setState({ showTable: true }))
	}

	handleRemoveHierarchyItems() {
		AppStateStore.setProgressSnackbarContent("loading")
		accountActions.deleteHierarchyItem(AccountStore.getCurrentAccount().Id, this.state.selectedHierarchyItems.map(item => item.Id), () => {
			AppStateStore.setProgressSnackbarContent(strings.Successfully_deleted)
		})
	}

	handleAdd(hierarchyItem: IHierarchyItem) {
		this.setState({ openAddHierarchyItemDialog: false })
		AppStateStore.setProgressSnackbarContent("loading")
		accountActions.addHierarchyItem(hierarchyItem,
			() => {
				AppStateStore.setProgressSnackbarContent(strings.Successfully_added)
				this.goToCreatedLevelLocation(hierarchyItem)
			}
		)
	}

	goToCreatedLevelLocation(createdHierarchyLevel: IHierarchyItem) {
		if (userHelper.getSupervisorAccessPermissionForHierarchy(createdHierarchyLevel)) {
			browserHistory.push("/hierarchy/location")
			setGlobalHierarchyLevel.setGlobalHierarchyLevel(createdHierarchyLevel)
		}
	}

	render() {
		return (
			<div className="hierarchy-component HierarchyComponent">
				{!this.props.readonly && this.props.canSelectedHaveChildren &&
					<FloatingActionButton
						data-intercom-target={"menu-Hierarchy-Children-Btn-AddHierarchyDialog"}
						secondary
						className="fixed-add"
						style={{ top: -28, right: 20, zIndex: 500 }}
						onTouchTap={() => this.props.childLevel ?
							this.setState({ openAddHierarchyItemDialog: true }) :
							AppStateStore.setProgressSnackbarContent(strings.Add_Hierarchy_Definition)
						}
					>
						<ContentAdd />
					</FloatingActionButton>
				}
				<div style={{ paddingBottom: 30 }}>
					<div style={{ display: "block" }}>
						{this.state.showTableActionBar &&
							<TableActionBar
								onSearch={searchText =>
									this.setState({
										showTable: false,
										searchText,
										filteredHierarchyItems: this.getFilteredHierarchyItems(searchText),
										selectedHierarchyItems: []
									}, () => this.setState({ showTable: true }))
								}
								searchText={this.state.searchText}
								rowSelectionCount={this.state.selectedHierarchyItems.length}
								onCloseSearchClick={() => this.setState({ searchText: "" })}
								multipleSelectedMessage={strings.x_Hierarchy_Items_Selected}
								singleSelectedMessage={strings.Hierarchy_Item_Selected}
								title={this.props.childLevel ? this.props.childLevel.Label : ""}
								titleStyle={{ fontSize: 16 }}
								bodyStyle={{ padding: 20, fontWeight: 500 }}
								onSearchClick={() => this.setState({ selectedHierarchyItems: [] })}
								onDeleteClick={this.onDeleteHierarchyItem}
							/>
						}
						{this.state.filteredHierarchyItems.length > 0 ?
							this.state.showTable &&
							<Table
								selectable={!this.props.readonly}
								multiSelectable={!this.props.readonly}
								allRowsSelected={this.state.selectedHierarchyItems.length === this.state.filteredHierarchyItems.length}
								onCellClick={this.handelCellClick}
								onRowSelection={this.handleRowSelection}
							>
								<TableHeader>
									<TableRow>
										<TableHeaderColumn>{strings.Name}</TableHeaderColumn>
										<TableHeaderColumn>{strings.HierarchyLevel}</TableHeaderColumn>
										<TableHeaderColumn>{strings.CostCenter}</TableHeaderColumn>
									</TableRow>
								</TableHeader>
								<TableBody showRowHover deselectOnClickaway={false}>
									{this.state.filteredHierarchyItems.map((row, i) =>
										<TableRow data-intercom-target={i === 0 && "menu-Hierarchy-Children-SelectChildren"} key={i} style={{ heigth: 45, cursor: "pointer" }} selected={this.state.selectedHierarchyItems.indexOf(row) > -1}>
											<TableRowColumn>{row.Label}</TableRowColumn>
											<TableRowColumn>{AccountStore.getCurrentAccount().HierarchyDefinitions.find(item => item.Id === row.HierarchyDefinitionId).Label}</TableRowColumn>
											<TableRowColumn>{row.CostCenter}</TableRowColumn>
										</TableRow>
									)}
								</TableBody>
							</Table> :
							<div style={{ textAlign: "center", fontSize: 30, fontWeight: "bold", marginTop: 30 }}>
								{strings.No_hierarchy_level}
							</div>
						}
					</div>
				</div>
				{this.state.openAddHierarchyItemDialog &&
					<AddHierarchyItemDialog
						hierarchyDefinition={this.props.childLevel}
						currentHierarchyItem={this.props.hierarchyItem}
						handleAdd={this.handleAdd}
						handleClose={() => this.setState({ openAddHierarchyItemDialog: false })}
					/>
				}
			</div>
		)
	}
}